export const DATE_PLUS13 = 'DATE_DPLUS13_WORK_DAY_DATE';
export const DATE_PLUS30 = 'DATE_DPLUS30_WORK_DAY_DATE';
export const WORK_DAY_FLAG = 'DATE_WORK_DAY_FLAG';
export const POSITIVE_VALUE = 'Y';
export const MOBILITY_DEFAULT_CURRENCY_CODE = 'CZK';
export const MobilityScope = {
    TRANSFER_BALANCE: 'TRANSFER_BALANCE',
    TRANSFER_ALL_STANDING_ORDERS_AND_DIRECT_DEBITS: 'TRANSFER_ALL_STANDING_ORDERS_AND_DIRECT_DEBITS',
    CANCEL_ACCOUNT: 'CANCEL_ACCOUNT',
};
